import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { All } from "../../../../Util/Constants/Quantities"
import { Music } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"

export function CycleOfSecondsMap(){
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:7, columns:11, tonic:Music.G, radius:38}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setHilited([10,19,29,38,48,57,67])
        //mod.keys_setPositionAsLabel([All])
        return map
    }
    const map:HexMap = getMap()
    const [width,height] = [850,600]
    return(
        <div>
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2, height/2)}>
                    <HxMapGroup hexMap={map}/>
                </g>
            </svg>
        </div>
    )
}